import HotelsWithClosestDistance from './HotelsWithClosestDistance';

export default HotelsWithClosestDistance;
